// hooks/useThemeSync.js
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectTheme, setMode } from "../store/reducers/theme";

export const useThemeSync = () => {
  const dispatch = useDispatch();
  const { mode } = useSelector(selectTheme);

  useEffect(() => {
    const html = document.documentElement;

    // System preference handler
    const handleSystemChange = (e) => {
      const systemMode = e.matches ? "dark" : "light";
      html.classList.toggle("dark", systemMode === "dark");
      dispatch(setMode("system")); // Force resolvedMode update
    };

    if (mode === "system") {
      // Set initial system theme
      const systemDark = window.matchMedia("(prefers-color-scheme: dark)");
      handleSystemChange(systemDark);

      // Listen for system theme changes
      systemDark.addEventListener("change", handleSystemChange);
      return () => systemDark.removeEventListener("change", handleSystemChange);
    } else {
      // Direct theme control
      html.classList.toggle("dark", mode === "dark");
    }
  }, [mode, dispatch]); // Only re-run when mode changes
};
